"use strict";
var pushNotification = function(posTop, posRight, title, description, type) {
    // write code here
    // створюємо контейнер повідомлення
    var notification = document.createElement("div");
    notification.className = "notification ".concat(type);
    notification.style.top = "".concat(posTop, "px");
    notification.style.right = "".concat(posRight, "px");
    // заголовок
    var titleEl = document.createElement("h2");
    titleEl.className = "title";
    titleEl.textContent = title;
    // опис
    var descEl = document.createElement("p");
    descEl.textContent = description;
    notification.appendChild(titleEl);
    notification.appendChild(descEl);
    document.body.appendChild(notification);
    // приховуємо через таймер
    setTimeout(function() {
        notification.style.visibility = "hidden";
    }, 2000);
};
pushNotification(10, 10, "Title of Success message", "Message example.\n Notification should contain title and description.", "success");
pushNotification(150, 10, "Title of Error message", "Message example.\n Notification should contain title and description.", "error");
pushNotification(290, 10, "Title of Warning message", "Message example.\n Notification should contain title and description.", "warning");

//# sourceMappingURL=index.da68ec7b.js.map
